import React, { useState } from 'react';
import { TouchableOpacity, View, type ViewStyle } from 'react-native';
import { Menu } from 'react-native-material-menu';
import Text from '~/components/Text';

import CloseSVG from '~/assets/svgs/close.svg';
import MenuSVG from '~/assets/svgs/list.svg';
import HomeSVG from '~/assets/svgs/home.svg';
// import ListShieldSVG from '~/assets/svgs/list-shield.svg';
import DoorLeaveSVG from '~/assets/svgs/door-leave.svg';
import colors from '~/assets/themes/colors';
import type { SvgProps } from 'react-native-svg';
import { useUserInfoStore } from '~/stores/userInfo';
import useAppNavigation from '~/hooks/useAppNavigation';
import { isWeb } from '~/utils/device';

interface MenuItemProps {
  icon: React.FC<SvgProps>;
  description: string | React.ReactElement;
  onPress: () => void;
}

const MenuItem = ({ icon: Icon, description, onPress }: MenuItemProps) => {
  return (
    <TouchableOpacity
      className="flex-row items-center"
      onPress={onPress}
      activeOpacity={0.6}
    >
      <Icon color={colors.gray[400]} width={24} height={24} />
      <Text className="text-gray-400 text-sm ml-4 flex-1">{description}</Text>
    </TouchableOpacity>
  );
};

const FloatingMenu: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const { navigate } = useAppNavigation();

  const menuItems: MenuItemProps[] = [
    {
      icon: HomeSVG,
      description: 'Home Marisa Serviços',
      onPress: () => {
        setVisible(false);
        navigate('MarisaServicos_Home');
      },
    },
    // {
    //   icon: ListShieldSVG,
    //   description: 'Meus serviços contratados',
    //   navigateTo: 'Home',
    // },
    {
      icon: DoorLeaveSVG,
      description: <Text className="text-feedback-error-main">Sair</Text>,
      onPress: async () => {
        await useUserInfoStore.getState().logout();
        setVisible(false);
        navigate('MarisaServicos_Home');
      },
    },
  ];

  const menuStyle: ViewStyle = {
    marginTop: 32,
    borderRadius: 8,
    width: isWeb ? '20%' : '70%',
    borderWidth: isWeb ? 1 : 0,
    borderColor: colors.gray[100],
  };

  return (
    <Menu
      style={menuStyle}
      visible={visible}
      anchor={
        <TouchableOpacity activeOpacity={0.6} onPress={() => setVisible(true)}>
          {visible ? (
            <CloseSVG height={24} width={24} color={colors.gray[400]} />
          ) : (
            <MenuSVG />
          )}
        </TouchableOpacity>
      }
      onRequestClose={() => setVisible(false)}
    >
      <View className="p-4">
        {menuItems.map((menuItem, index) => {
          return (
            <View key={index}>
              <MenuItem {...menuItem} />
              {index < menuItems.length - 1 && (
                <View className="my-4 bg-gray-100 h-[1px] w-full" />
              )}
            </View>
          );
        })}
      </View>
    </Menu>
  );
};

export default FloatingMenu;
